<template>
  <div>
   
    <br />
     <Menu></Menu>
     <div class="grid-responsive">
          <h1 class="title">Motoristas</h1>
  
          <br />           
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Criação</th>
                  <th>Nome</th>
                  <th>Email</th>                    
                  <th>Telefone</th>                    
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{item.idMotorista}}</td> 
                  <td>{{item.dataCriacao}}</td>                                    
                  <td>{{item.nome}}</td>                   
                  <td>{{item.email}}</td>                     
                  <td>{{item.tel}}</td>   
                  <td>
                    <a :href="item.href" target="_black" style="color:#FF5E00;font-size:17pt">
                      <i class="fab fa-whatsapp" style=""></i>
                    </a>
                  </td>                  
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
   
</template>

<style scoped>
tfoot {
  background-color: #fff;
}
#buttonActions {
  margin-top: 30px;
}
</style>

<script>

import moment from "moment"
import Menu from "@/components/MenuAdmin.vue";
import {AdminService} from "@/http"

import {formatCellPhone} from "@/utils"

export default {
  name: "motoristasAdmin",
  components: {
    Menu,   
  },
  data: () => {
    return {
      items:[],  
      showModal: false,  
    };
  },
  methods: {
     
    motoristas(){

      AdminService.Motoristas().then(response=>{
       this.items = response.data.map(item=>{

           item.dataCriacao = moment(item.dataCriacao).utc().locale("pt-br").format("DD/MM/YYYY H:mm")
           item.tel = formatCellPhone(item.telefone)
           
           item.href = `https://api.whatsapp.com/send?phone=55${item.telefone}&text=Ol%C3%A1%21+Bem+vindo+%C3%A0+Soganhei+`

           return item
       })

      }).catch(error=>{
          window.console.log(error)
      })

    },  
     
  },
  created() {
    this.motoristas()
   
  }, 
  watch:{
    //searchServicos: _.debounce(function(text) { this.handlerServicos(text) }, 500),  
  }
};
</script>
 
